<script>
  import { createEventDispatcher } from 'svelte';

  import { InlineNotification, Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../LoadingSpinner.svelte';
  import { deleteExternalKey } from '../../services';

  export let key,
    open = false;

  let loading = false,
    resultNotification;

  const dispatch = createEventDispatcher();

  async function deleteKey() {
    loading = true;

    try {
      await deleteExternalKey(key.id);

      dispatch('close', { id: key.id });
    } catch (error) {
      console.error('[DeleteKeyModal] Failed to delete key!', error);
      resultNotification = {
        hideCloseButton: false,
        kind: 'error',
        title: 'Error:',
        subtitle: 'Failed to delete key! Please try again later.',
      };
    } finally {
      loading = false;
    }
  }

  function onModalClose() {
    dispatch('close');
  }
</script>

<Modal
  danger
  modalHeading="Delete Key"
  preventCloseOnClickOutside={true}
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  primaryButtonDisabled={loading}
  size="sm"
  bind:open
  on:click:button--secondary={onModalClose}
  on:close={onModalClose}
  on:submit={deleteKey}
>
  <LoadingSpinner {loading}>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
      />
    {/if}
    <p>You are about to delete external key <strong>{key.name}</strong>.</p>
    <br />
    <p>Are you sure?</p>
  </LoadingSpinner>
</Modal>
